import { apiService } from './api';
import { Agent, CreateAgentDto, UpdateAgentDto, AgentListRequest, AgentListResponse } from '../types/agent';

export const agentsService = {
  // Get agents with pagination
  getAgents: async (params: AgentListRequest = {}): Promise<AgentListResponse> => {
    const response = await apiService.get<AgentListResponse>('/agents', params);
    return response.data;
  },

  // Get agent by ID
  getById: async (id: number): Promise<Agent> => {
    const response = await apiService.get<Agent>(`/agents/${id}`);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to fetch agent');
    }
    return response.data;
  },

  // Create new agent
  create: async (data: CreateAgentDto): Promise<Agent> => {
    const response = await apiService.post<Agent>('/agents', data);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to create agent');
    }
    return response.data;
  },

  // Update agent
  update: async (id: number, data: UpdateAgentDto): Promise<Agent> => {
    const response = await apiService.put<Agent>(`/agents/${id}`, data);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to update agent');
    }
    return response.data;
  },

  // Delete agent
  delete: async (id: number): Promise<{ success: boolean; message?: string }> => {
    const response = await apiService.delete<void>(`/agents/${id}`);
    return { success: response.success, message: response.message };
  },
};
